import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store/index.js';

const routes = [
    {
        path: '/',
        name: 'home',
        exact: true,
    },
    {
        path: '/login_sso',
        name: 'login_sso',
        exact: true,
        component: () => import('./pages/login_simadu.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        exact: true,
        component: () => import('./components/Dashboard.vue'),
        meta: {
            breadcrumb: [{ label: 'Dashboard' }],
            requiresAuth: true,
        },
    },
    {
        path: '/landing_page',
        name: 'Landing Page',
        component: () => import('./pages/LandingPage.vue'),
    },
    {
        path: '/payment',
        name: 'Payment',
        component: () => import('./views/payment_mahasiswa/payment_index.vue'),
        meta: {
            requiresAuth: true,
            role: ['MS', '99'],
        },
    },
    {
        path: '/pencarian_mahasiswa',
        name: 'Pencarian Mahasiswa',
        component: () => import('./views/pencarian_mahasiswa/pencarian_mahasiswa.vue'),
        meta: {
            requiresAuth: true,
            role: ['MS', '99', 'OPADAK', 'OPP'],
        },
    },
    {
        path: '/billing_mahasiswa',
        name: 'Billing Mahasiswa',
        component: () => import('./views/billing/billing.vue'),
        meta: {
            requiresAuth: true,
            role: ['99', 'OPADAK', 'OPP', 'KPRO'],
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('./pages/Login.vue'),
    },
    {
        path: '/agama',
        name: 'Agama',
        exact: true,
        component: () => import('./views/Master/agama/agama.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Agama' }],
            requiresAuth: true,
            role: ['OPP', '99'],
        },
    },
    {
        path: '/role',
        name: 'Role',
        exact: true,
        component: () => import('./views/Master/role/role.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Role' }],
            requiresAuth: true,
            role: ['99'],
        },
    },
    {
        path: '/manajemen_nilai',
        name: 'Manajemen Nilai',
        exact: true,
        component: () => import('./views/Nilai/manajemen_nilai/rumus_nilai.vue'),
        meta: {
            breadcrumb: [{ parent: 'Nilai', label: 'Manajemen Nilai' }],
            requiresAuth: true,
            role: ['OPP', '99', 'DS'],
        },
    },
    {
        path: '/nilai_mahasiswa',
        name: 'Nilai Mahasiswa',
        exact: true,
        component: () => import('./views/Nilai_Mahasiswa/nilai_mahasiswa.vue'),
        meta: {
            breadcrumb: [{ label: 'Nilai Mahasiswa' }],
            requiresAuth: true,
            role: ['DS', '99'],
        },
    },
    {
        path: '/skala_nilai_prodi',
        name: 'Skala Nilai Prodi',
        exact: true,
        component: () => import('./views/Nilai/pool_skala_nilai/pool_skala_nilai.vue'),
        meta: {
            breadcrumb: [{ parent: 'Nilai', label: 'Skala Nilai Prodi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'DS'],
        },
    },
    {
        path: '/users',
        name: 'users',
        exact: true,
        component: () => import('./views/User/user.vue'),
        meta: {
            breadcrumb: [{ label: 'User' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/alat_transportasi',
        name: 'Alat Transportasi',
        exact: true,
        component: () => import('./views/Master/alat_transportasi/alat_transportasi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Alat Transportasi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jalur_masuk',
        name: 'Jalur Masuk',
        exact: true,
        component: () => import('./views/Master/jalur_masuk/jalur_masuk.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jalur Masuk' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jenis_keluar',
        name: 'Jenis Keluar',
        exact: true,
        component: () => import('./views/Master/jenis_keluar/jenis_keluar.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jenis Keluar' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/kategori_skpi',
        name: 'Kategori SKPI',
        exact: true,
        component: () => import('./views/Master/kategori_skpi/kategori_skpi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Kategori SKPI' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jenis_tinggal',
        name: 'Jenis Tinggal',
        exact: true,
        component: () => import('./views/Master/jenis_tinggal/jenis_tinggal.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jenis Tinggal' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jenis_evaluasi',
        name: 'Jenis Evaluasi',
        exact: true,
        component: () => import('./views/Master/jenis_evaluasi/jenis_evaluasi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jenis Evaluasi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jenis_substansi',
        name: 'Jenis Substansi',
        exact: true,
        component: () => import('./views/Master/jenis_substansi/jenis_substansi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jenis Substansi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jenjang_pendidikan',
        name: 'Jenjang Pendidikan',
        exact: true,
        component: () => import('./views/Master/jenjang_pendidikan/jenjang_pendidikan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jenjang Pendidikan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/kebutuhan_khusus',
        name: 'Kebutuhan Khusus',
        exact: true,
        component: () => import('./views/Master/kebutuhan_khusus/kebutuhan_khusus.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Kebutuhan Khusus' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/negara',
        name: 'Negara',
        exact: true,
        component: () => import('./views/Master/negara/negara.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Negara' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/pekerjaan',
        name: 'Pekerjaan',
        exact: true,
        component: () => import('./views/Master/pekerjaan/pekerjaan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Pekerjaan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/pembiayaan',
        name: 'Pembiayaan',
        exact: true,
        component: () => import('./views/Master/pembiayaan/pembiayaan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Pembiayaan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/wilayah',
        name: 'Wilayah',
        exact: true,
        component: () => import('./views/Master/wilayah/wilayah.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Wilayah' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/penghasilan',
        name: 'Penghasilan',
        exact: true,
        component: () => import('./views/Master/penghasilan/penghasilan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Penghasilan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/status_mahasiswa',
        name: 'Status Mahasiswa',
        exact: true,
        component: () => import('./views/Master/status_mahasiswa/status_mahasiswa.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Status Mahasiswa' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/fakultas',
        name: 'Fakultas',
        exact: true,
        component: () => import('./views/Master/fakultas/fakultas.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Fakultas' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/prodi',
        name: 'Program Studi',
        exact: true,
        component: () => import('./views/Master/prodi/prodi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Program Studi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/tahun_ajaran',
        name: 'Tahun Ajaran',
        exact: true,
        component: () => import('./views/Master/tahun_ajaran/tahun_ajaran.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Tahun Ajaran' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/semester',
        name: 'Semester',
        exact: true,
        component: () => import('./views/Master/semester/semester.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Semester' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/bidang_minat',
        name: 'Bidang Minat',
        exact: true,
        component: () => import('./views/Master/bidang_minat/bidang_minat.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Bidang Minat' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/dosen',
        name: 'Dosen',
        exact: true,
        component: () => import('./views/Master/dosen/dosen.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Dosen' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/mahasiswa',
        name: 'Mahasiswa',
        exact: true,
        component: () => import('./views/Master/mahasiswa/mahasiswa.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Mahasiswa' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/mata_kuliah',
        name: 'Mata Kuliah',
        exact: true,
        component: () => import('./views/perkuliahan/mata_kuliah/mata_kuliah.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Mata Kuliah' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/ms_perwalian',
        name: 'Master Perwalian',
        exact: true,
        component: () => import('./views/Master/perwalian/perwalian.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Perwalian' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'DS', 'OPJ', 'OPADAK'],
        },
    },
    {
        path: '/kurikulum',
        name: 'Kurikulum',
        exact: true,
        component: () => import('./views/perkuliahan/kurikulum/kurikulum.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Kurikulum' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/mata_kuliah_kurikulum',
        name: 'Mata Kuliah Kurikulum',
        exact: true,
        component: () => import('./views/perkuliahan/mata_kuliah_kurikulum/mata_kuliah_kurikulum.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Mata Kuliah Kurikulum' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/kelas_kuliah',
        name: 'Kelas Kuliah',
        exact: true,
        component: () => import('./views/perkuliahan/kelas_kuliah/kelas_kuliah.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Kelas Kuliah' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/mahasiswa_kelas',
        name: 'Kelas Mahasiswa',
        exact: true,
        component: () => import('./views/Master/pool_mahasiswa_kelas/pool_mahasiswa_kelas.vue'),
        meta: {
            breadcrumb: [{ parent: 'Mahasiswa', label: 'Kelas Mahasiswa' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/substansi_kuliah',
        name: 'Substansi Kuliah',
        exact: true,
        component: () => import('./views/perkuliahan/substansi_kuliah/substansi_kuliah.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Substansi Kuliah' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/dosen_kelas',
        name: 'Kelas Dosen',
        exact: true,
        component: () => import('./views/Master/pool_dosen_kelas/pool_dosen_kelas.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dosen', label: 'Kelas Dosen' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'KJUR', 'OPADAK'],
        },
    },
    {
        path: '/mata_kuliah_semester',
        name: 'Mata Kuliah Semester',
        exact: true,
        component: () => import('./views/Master/mata_kuliah_semester/mata_kuliah_semester.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Mata Kuliah Semester' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/mata_kuliah_semester_kurikulum',
        name: 'Mata Kuliah Semester Kurikulum',
        exact: true,
        component: () => import('./views/Master/pool_mk_smt_kurikulum/pool_mk_smt_kurikulum.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Mata Kuliah Semester Kurikulum' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/ruangan',
        name: 'Ruangan',
        exact: true,
        component: () => import('./views/Master/ruangan/ruangan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Ruangan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/gedung',
        name: 'Gedung',
        exact: true,
        component: () => import('./views/Master/gedung/gedung.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Gedung' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/kampus',
        name: 'Kampus',
        exact: true,
        component: () => import('./views/Master/kampus/kampus.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Kampus' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/kegiatan_akademik',
        name: 'Kegiatan Akademik',
        exact: true,
        component: () => import('./views/Master/kegiatan_akademik/kegiatan_akademik.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master', label: 'Kegiatan Akademik' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jadwal',
        name: 'Jadwal',
        exact: true,
        component: () => import('./views/Master/jadwal/jadwal.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master Data', label: 'Jadwal' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/paket_krs',
        name: 'Paket KRS',
        exact: true,
        component: () => import('./views/perkuliahan/paket_krs/paket_krs.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Paket KRS' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/pool_krs_jadwal/:id',
        name: 'KRS Jadwal',
        exact: true,
        component: () => import('./views/perkuliahan/pool_krs_jadwal/pool_krs_jadwal.vue'),
        meta: {
            breadcrumb: [{ parent: 'Paket KRS', label: 'KRS Jadwal' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/pool_krs_peserta/:id',
        name: 'KRS Peserta',
        exact: true,
        component: () => import('./views/perkuliahan/pool_krs_peserta/pool_krs_peserta.vue'),
        meta: {
            breadcrumb: [{ parent: 'Paket KRS', label: 'KRS Peserta' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/absensi',
        name: 'Absensi',
        exact: true,
        component: () => import('./views/absensi/absensi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Absensi', label: 'Absensi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'DS'],
        },
    },
    {
        path: '/rekap_absensi/:id',
        name: 'Rekap Absensi',
        exact: true,
        component: () => import('./views/absensi/rekap_absensi/rekap_absensi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Absensi', label: 'Rekap Absensi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/her_registrasi',
        name: 'Her Registrasi',
        exact: true,
        component: () => import('./views/her_reg/her_reg.vue'),
        meta: {
            breadcrumb: [{ parent: 'Her Registrasi', label: 'Her Registrasi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'KPRO', 'OPJ', 'KJUR', 'OPJ'],
        },
    },
    {
        path: '/belum_her_registrasi',
        name: 'Belum Her Registrasi',
        exact: true,
        component: () => import('./views/her_reg/her_reg_belum.vue'),
        meta: {
            breadcrumb: [{ parent: 'Her Registrasi', label: 'Belum Her Registrasi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'KPRO', 'OPJ', 'KJUR', 'OPJ'],
        },
    },
    {
        path: '/menunggu_lulus',
        name: 'Menunggu Kelulusan',
        exact: true,
        component: () => import('./views/her_reg/menunggu.vue'),
        meta: {
            breadcrumb: [{ parent: 'Her Registrasi', label: 'Menunggu Lulus' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'KPRO', 'OPJ', 'KJUR', 'OPJ'],
        },
    },
    {
        path: '/tidak_aktif',
        name: 'Tidak Aktif',
        exact: true,
        component: () => import('./views/her_reg/tidak_aktif.vue'),
        meta: {
            breadcrumb: [{ parent: 'Her Registrasi', label: 'Mahasiswa Tidak Aktif' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'KPRO', 'OPJ', 'KJUR', 'OPJ'],
        },
    },
    {
        path: '/jadwal_dosen',
        name: 'Jadwal Dosen',
        exact: true,
        component: () => import('./components/dashboard_dosen/jadwal_dosen.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard Dosen', label: 'Jadwal Dosen' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPJ'],
        },
    },
    {
        path: '/list_mahasiswa_kelas/:id',
        name: 'List Mahasiswa',
        exact: true,
        component: () => import('./components/dashboard_dosen/list_mahasiswa.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard Dosen', label: 'List Mahasiswa' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/list_skkm_mahasiswa/:id',
        name: 'List SKKM',
        exact: true,
        component: () => import('./components/dashboard_dosen/list_skkm.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard Dosen', label: 'List SKKM' }],
            role: ['OPP', 'MS', '99', 'DS'],
        },
    },
    {
        path: '/cuti',
        name: 'Pengajuan Cuti',
        exact: true,
        component: () => import('./views/Cuti/cuti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Her Registrasi', label: 'Pengajuan Cuti' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'KJUR', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/her_reg_cuti',
        name: 'Cuti',
        exact: true,
        component: () => import('./views/Cuti/her_reg_cuti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Her Registrasi', label: 'Herreg Cuti' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'KJUR', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/pengajuan_tugas_akhir',
        name: 'Tugas Akhir',
        exact: true,
        component: () => import('./views/Tugas_Akhir/tugas_akhir.vue'),
        meta: {
            breadcrumb: [{ parent: 'Tugas Akhir', label: 'Pengajuan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/ujian_akhir',
        name: 'Ujian Akhir',
        exact: true,
        component: () => import('./views/Ujian/ujian.vue'),
        meta: {
            breadcrumb: [{ parent: 'Tugas Akhir', label: 'Ujian' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'OPADAK'],
        },
    },
    {
        path: '/lulus_do',
        name: 'Lulus DO',
        exact: true,
        component: () => import('./views/Lulus_DO/lulus_do.vue'),
        meta: {
            breadcrumb: [{ parent: 'Mahasiswa', label: 'Lulus / DO' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'KPRO', 'OPADAK'],
        },
    },
    {
        path: '/periode_perkuliahan',
        name: 'Periode Perkuliahan',
        exact: true,
        component: () => import('./views/Periode_Perkuliahan/periode_perkuliahan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Kalender Akademik', label: 'Periode Perkuliahan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'OPJ'],
        },
    },
    {
        path: '/kalender_akademik',
        name: 'Kalender Akademik',
        exact: true,
        component: () => import('./views/Kalender_Akademik/kalender_akademik.vue'),
        meta: {
            breadcrumb: [{ parent: 'Kalender Akademik', label: 'kalender' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/dasar_penilaian',
        name: 'dasar_penilaian',
        exact: true,
        component: () => import('./views/Master/dasar_penilaian/dasar_penilaian.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master', label: 'dasar_penilaian' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'DS'],
        },
    },
    {
        path: '/master_skkm',
        name: 'Master SKKM',
        exact: true,
        component: () => import('./views/Master/skkm/skkm.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master', label: 'SKKM' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/skkm_mahasiswa',
        name: 'SKKM Mahasiswa',
        exact: true,
        component: () => import('./views/mahasiswa/skkm/skkm.vue'),
        meta: {
            breadcrumb: [{ parent: 'SKKM', label: 'List SKKM' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/skpi',
        name: 'SKPI',
        exact: true,
        component: () => import('./views/mahasiswa/skpi/skpi.vue'),
        meta: {
            breadcrumb: [{ parent: 'SKPI', label: 'skpi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK'],
        },
    },
    {
        path: '/peserta_wisuda',
        name: 'Peserta Wisuda',
        exact: true,
        component: () => import('./views/wisuda/wisuda/wisuda.vue'),
        meta: {
            breadcrumb: [{ parent: 'Wisuda', label: 'Peserta Wisuda' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99', 'OPADAK', 'OPJ', 'OPPUS'],
        },
    },
    {
        path: '/periode_wisuda',
        name: 'Periode Wisuda',
        exact: true,
        component: () => import('./views/wisuda/periode_wisuda.vue'),
        meta: {
            breadcrumb: [{ parent: 'Wisuda', label: 'Periode Wisuda' }],
            requiresAuth: true,
            role: ['OPP', '99', 'MS', 'OPADAK'],
        },
    },
    {
        path: '/akreditas_prodi',
        name: 'Akresitas Prodi',
        exact: true,
        component: () => import('./views/penjamin_mutu/akreditas_prodi/akreditas_prodi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Penjamin Mutu', label: 'Akresitas Prodi' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/perwalian',
        name: 'Perwalian',
        exact: true,
        component: () => import('./views/mahasiswa/perwalian/perwalian.vue'),
        meta: {
            breadcrumb: [{ parent: 'Penjamin Mutu', label: 'Perwalian' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/perjadwalan',
        name: 'Perjadwalan',
        exact: true,
        component: () => import('./views/perkuliahan/perjadwalan/perjadwalan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Perjadwalan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/uas',
        name: 'Uas',
        exact: true,
        component: () => import('./views/perkuliahan/uas/uas.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Uas' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/jadwal_ruangan',
        name: 'jadwal Ruangan',
        exact: true,
        component: () => import('./views/ruangan/jadwal_ruangan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Management Ruangan', label: 'Jadwal' }],
            requiresAuth: true,
            role: ['OPP', '99', 'OPADAK'],
        },
    },
    {
        path: '/list_booking',
        name: 'Booking Ruangan',
        exact: true,
        component: () => import('./views/ruangan/list_booking.vue'),
        meta: {
            breadcrumb: [{ parent: 'Management Ruangan', label: 'Booking' }],
            requiresAuth: true,
            role: ['OPP', '99', 'OPADAK'],
        },
    },
    {
        path: '/uts',
        name: 'Uts',
        exact: true,
        component: () => import('./views/perkuliahan/uts/uts.vue'),
        meta: {
            breadcrumb: [{ parent: 'Perkuliahan', label: 'Uts' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/profil_pt',
        name: 'Profil PT',
        exact: true,
        component: () => import('./views/penjamin_mutu/profil_pt/profil_pt.vue'),
        meta: {
            breadcrumb: [{ parent: 'Penjaminan Mutu', label: 'Profil PT' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    {
        path: '/periode_perkuliahan',
        name: 'Periode Perkuliahan',
        exact: true,
        component: () => import('./views/Master/periode_perkuliahan/periode_perkuliahan.vue'),
        meta: {
            breadcrumb: [{ parent: 'Master', label: 'Periode Perkuliahan' }],
            requiresAuth: true,
            role: ['OPP', 'MS', '99'],
        },
    },
    // {
    //     path: '/mata_kuliah_kurikulum',
    //     name: 'Mata Kuliah Kurikulum',
    //     exact: true,
    //     component: () => import('./views/Master/mata_kuliah_kurikulum/mata_kuliah_kurikulum.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'Master Data', label: 'Mata Kuliah Kurikulum' }],
    //     },
    // },
    {
        path: '/access',
        name: 'Access',
        exact: true,
        component: () => import('./pages/Access.vue'),
    },
    {
        path: '/logout',
        name: 'Logout',
        exact: true,
        meta: {
            requiresAuth: true,
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    let allow = !to.meta.role || to.meta.role.includes(store.state.simadu.role_aktif.kode_role);
    let token = store.state.simadu.sso_access_token;
    if (
        to.matched.some((r) => {
            // console.log(r.path);
            if (r.meta.requiresAuth == true) {
                if (token != null) {
                    if (r.path == '/logout') {
                        store.commit('set_clear_token');
                        next('/login_sso');
                    } else {
                        if (allow) {
                            next();
                        } else {
                            next('/access');
                        }
                    }
                } else {
                    next('/login_sso');
                }
            } else {
                if (token) {
                    if (r.path == '/login' || r.path == '/') {
                        next('/dashboard');
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            }
        })
    );
});

export default router;
